module.exports = __webpack_public_path__ + "img/24.23c5949e.jpg";